import axios from 'axios';
import xhrRoutes from './routes/xhr';
import Translator from './translator';
import stringifyObject from '../helpers/stringify-object';
import giveTranslation from './give-translations';

export default function () {
  const route = xhrRoutes.community.approve;
  const userApproveItems = document.querySelectorAll('.js-user-approve');
  const classUserCardInactive = 'user__item__card--inactive';
  let clicked = false;

  if (!userApproveItems.length) {
    return;
  }

  /**
   * Show notification after the response
   *
   * @param type
   * @param message
   */
  function showNotification(type, message) {
    const notification = document.createElement('div');
    notification.classList.add('notification');
    notification.classList.add('notification--' + type);
    notification.innerHTML = message;
    document.body.appendChild(notification);
  }

  [].forEach.call(userApproveItems, (userApproveItem) => {
    userApproveItem.addEventListener('click', (e) => {
      const communityId = userApproveItem.getAttribute('data-community-id');
      const userId = userApproveItem.getAttribute('data-user-id');

      if (!userId || !communityId || clicked) {
        return;
      }

      e.preventDefault();

      if (!confirm(giveTranslation('api.confirm.user.approve'))) {
        return;
      }

      clicked = true;

      const communityUser = document.querySelector(`[data-community-user="${communityId}_${userId}"]`);
      const communityLetterRow = document.querySelector(`[data-letter-count="${communityUser.dataset.communityUserLetter}_1"]`);

      communityUser.querySelector('.user__item__card').classList.add(classUserCardInactive);

      route.params.community_id = communityId;
      route.params.user_id = userId;

      axios.post(route.url, stringifyObject(route.params))
        .then((response) => {
          if (response.data.status === 'fail') {
            communityUser.querySelector('.user__item__card').classList.remove(classUserCardInactive);
            showNotification('error', Translator.trans('api.error.fail'));
          } else {
            communityUser.remove();

            if (typeof communityLetterRow !== 'undefined') {
              communityLetterRow.remove();
            }

            showNotification('success', Translator.trans('api.community.user.message.approved'));
            window.location.reload();
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .then(() => {
          // always executed
        });
    });
  });
};
